import { DialogUtility } from "@syncfusion/ej2-react-popups";
import debounce from "lodash/debounce";
import { v4 as uuidv4 } from 'uuid';
import { calenderAction } from "../../redux/reducer/calenderReducer";
import { checkSlot, checkSlotForCreateReservation, checkSlotOpenOrClose, checkSlotOpenOrCloseForSaveReservation, getCurrentDate, getCurrentDateByWeek, getCurrentView, isAllDayAvailable, canBookReservationAllDay, isReservationInThePast, PAST_RESERVATION_COPY } from "../../util/CalendarUtil";
import { createSchedule, deleteSchedule, updateSchedule } from "./CRUD";
import { Timezone } from "@syncfusion/ej2-react-schedule";
import { rootAction } from "../../redux/reducer/rootReducer";
import { Privileges } from "../../util/PrivilegeConstants";
import { canSetReservationAllDay, defaultReservationIsFree, freeReservationDialogCopy, MEMBER_PLAN_REQUIRED_COPY } from "../../util/calendarAccess";
import { isClubOwner, isClubStaff, isUser } from "../../util/UserRoles";
import { RESERVATION_PLAYER_REQUIRED, reservationPlayerOverCapMessage, showReservationEditorAlert } from "../../util/reservationPlayerSearch";


let dialogObj;

export const onSaveButtonClick = async (args, scheduleRef, user, currentGameId, dispatch, clubId, calendarConfig, advanceBookingDay, startLoading, finishLoading, selectedClub, chargesCourtTime = false, navigate) => {
    let currDate = new Date().toLocaleString("en-US", { timeZone: calendarConfig.calenderTimezone });
    let today = new Date(new Date(currDate));
    const tillAdvanceBooking = new Date(today.setDate(today.getDate() + Number(advanceBookingDay)));

    if (new Date(args.element.querySelector('#StartTime').ej2_instances[0].value).getTime() >= new Date(args.element.querySelector('#EndTime').ej2_instances[0].value).getTime()) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '350px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "The start time cannot exceed the end time.",
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
        scheduleRef.current.closeEditor();
        return;
    }
    const selectedPlayers = args.element.querySelector('#Player').ej2_instances[0].value || [];
    if (selectedPlayers.length == 0) {
        args.cancel = true;
        showReservationEditorAlert(args.element, RESERVATION_PLAYER_REQUIRED);
        return;
    }
    const overCapWarning = reservationPlayerOverCapMessage({
        staff: isClubOwner(user) || isClubStaff(user),
        player: isUser(user),
        selectedCount: selectedPlayers.length,
    });
    if (overCapWarning) {
        args.cancel = true;
        showReservationEditorAlert(args.element, overCapWarning);
        return;
    }
    let timezone = new Timezone();
    let subject;
    const freeToggle = args.element.querySelector('#ReservationIsFreeBtn');
    const staffBooking = isClubOwner(user) || isClubStaff(user);
    let isFree = freeToggle && typeof freeToggle.checked === 'boolean'
        ? freeToggle.checked
        : defaultReservationIsFree(selectedClub, undefined, chargesCourtTime);
    if (!staffBooking && chargesCourtTime) {
        isFree = false;
    }
    if (!isFree) {
        subject = args.target.classList.contains('e-appointment')
            ?
            args.data.Subject === "RESERVED"
                ?
                "RESERVED"
                :
                "IN PROGRESS"
            :
            "IN PROGRESS";
    } else {
        subject = "RESERVED"
    }


    //Collect form 
    const formData = {
        //If data for update then set ID=schedule's id OR generate id 
        Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
        Subject: subject,
        StartTime: timezone.removeLocalOffset(args.element.querySelector('#StartTime').ej2_instances[0].value).toISOString(),
        EndTime: timezone.removeLocalOffset(args.element.querySelector('#EndTime').ej2_instances[0].value).toISOString(),
        IsAllDay: args.element.querySelector('#IsAllDay').ej2_instances[0].checked,
        CourtNumber: args.element.querySelector('#CourtNumber').ej2_instances[0].value,
        Player: selectedPlayers,
        Description: args.element.querySelector('#reservation_description').value,
        IsFree: isFree,
    };


    if (!isClubOwner(user) && !isClubStaff(user)
        && (advanceBookingDay != 0 && tillAdvanceBooking < new Date(new Date(formData.StartTime).toLocaleString("en-US", { timeZone: "UTC" })))) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '350px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "You can do advance booking from today up to " + advanceBookingDay + " days",
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
        scheduleRef.current.closeEditor();
        return;
    }
    if (args.element.querySelector('#IsAllDay').ej2_instances[0].checked) {
        let timezone = new Timezone();
        let data = calendarConfig.workingDays;
        let time = args.element.querySelector('#StartTime').ej2_instances[0].value;
        data.forEach((item) => {
            if (item.day == new Date(time).getDay()) {
                const [hoursForStart, minutesForStart] = item.startHour.split(':');
                const [hoursForEnd, minutesForEnd] = item.endHour.split(':');
                let startTime = new Date(new Date(time).setHours(hoursForStart, minutesForStart, 0, 0));
                let endTime = new Date(new Date(time).setHours(hoursForEnd, minutesForEnd, 0, 0));
                formData.StartTime = timezone.removeLocalOffset(startTime).toISOString();
                formData.EndTime = timezone.removeLocalOffset(endTime).toISOString();
            }
        })
    }

    let dialogObj2;
    const showDialog = () => {
        return new Promise((resolve, reject) => {
            dialogObj2 = DialogUtility.confirm({
                title: 'Alert',
                width: '250px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                content: 'Are you sure you want to book All Day?',
                okButton: { text: 'Yes', click: () => { resolve(true); dialogObj2.hide() } },
                cancelButton: { text: 'Cancel', click: () => { resolve(false); dialogObj2.hide() } }
            });
        });
    }
    if (args.element.querySelector('#IsAllDay').ej2_instances[0].checked && isAllDayAvailable(formData.StartTime, formData.EndTime, calendarConfig)) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "All day is not available to book.",
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
        scheduleRef.current.closeEditor();
        return;
    }
    if (args.element.querySelector('#IsAllDay').ej2_instances[0].checked) {
        const isConfirmed = await showDialog();
        if (isConfirmed) {
            scheduleRef.current.closeEditor();
        } else {
            scheduleRef.current.closeEditor();
            return;
        }

    }


    if (!checkSlotOpenOrCloseForSaveReservation(formData.StartTime, formData.EndTime, calendarConfig)) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: 'This slot has closed.',
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
        scheduleRef.current.closeEditor();
        return;
    }
    if (args.target.classList.contains('e-appointment')) {
        if (!checkSlotForCreateReservation(formData.StartTime, formData.EndTime, formData.CourtNumber, formData.Id, scheduleRef)) {
            dialogObj = DialogUtility.alert({
                title: 'Alert',
                width: '250px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                content: 'This slot has already been booked.',
                okButton: { click: alertOkAction },
            });
            args.cancel = true;
            scheduleRef.current.closeEditor();
            scheduleRef.current.refreshTemplates();
            return;
        }
        else {
            scheduleRef.current.closeEditor();
            const debouncedDispatchUpdate = debounce((formData) => {
                dispatch(calenderAction.updateSchedule(formData));
                finishLoading();
            }, 420);
            //Update schedule in database
            startLoading();
            updateSchedule(formData, user, currentGameId, clubId)
                .then((res) => {
                    debouncedDispatchUpdate(formData);
                })
                .catch((error) => {
                    finishLoading()
                    dialogObj = DialogUtility.alert({
                        title: 'Alert',
                        width: '250px',
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' },
                        content: "There was an error, Please contact customer support.",
                        okButton: { click: alertOkAction },
                    });
                })
        }
    } else {
        if (!checkSlotForCreateReservation(formData.StartTime, formData.EndTime, formData.CourtNumber, formData.Id, scheduleRef)) {
            dialogObj = DialogUtility.alert({
                title: 'Alert',
                width: '250px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                content: 'This slot is already booked',
                okButton: { click: alertOkAction },
            });
            args.cancel = true;
            scheduleRef.current.closeEditor();
            scheduleRef.current.refreshTemplates();
            return;
        }

        const confirmIsFreeAction = () => {
            scheduleRef.current.closeEditor();
            dialogObj.hide();
            const debouncedDispatchAdd = debounce((formData) => {
                dispatch(calenderAction.setSchedule(formData));
                scheduleRef.current.refreshTemplates();
                finishLoading();
            }, 420);
            startLoading();
            createSchedule(formData, user, currentGameId, clubId)
                .then((res) => {
                    debouncedDispatchAdd(formData)
                })
                .catch((error) => {
                    finishLoading();
                    dialogObj = DialogUtility.alert({
                        title: 'Alert',
                        width: '250px',
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' },
                        content: "There was an error, Please contact customer support.",
                        okButton: { click: alertOkAction },
                    });
                })
        }
        const confirmCancelAction = () => {
            dialogObj.hide();
            scheduleRef.current.closeEditor();
            scheduleRef.current.refreshTemplates();
        }
        if (!isFree) {
            scheduleRef.current.closeEditor();
            const debouncedDispatchAdd = debounce((formData) => {
                dispatch(calenderAction.setSchedule(formData));
                dispatch(rootAction.setReservationPaymentStatus({
                    status: true,
                    type: 'created'
                }));
                scheduleRef.current.refreshTemplates();
                finishLoading();
            }, 420);
            // Create schedule in database
            startLoading();
            createSchedule(formData, user, currentGameId, clubId)
                .then((res) => {
                    debouncedDispatchAdd(formData);
                    navigate?.('/cart');
                })
                .catch((error) => {
                    finishLoading();
                    dialogObj = DialogUtility.alert({
                        title: 'Alert',
                        width: '250px',
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' },
                        content: "There was an error, Please contact customer support.",
                        okButton: { click: alertOkAction },
                    });
                })
        }
        if (isFree) {
            const freeCopy = freeReservationDialogCopy(selectedClub);
            dialogObj = DialogUtility.confirm({
                title: freeCopy.title,
                content: freeCopy.content,
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: { click: confirmIsFreeAction },
                cancelButton: { click: confirmCancelAction }
            });


        }
    }

}


export const onDeleteButtonClick = (args, scheduleRef, dispatch, clubId, status, startLoading, finishLoading) => {
    if (args?.data?.Id) {
        scheduleRef.current.closeEditor();
        const debouncedDispatchDelete = debounce((id) => {
            dispatch(calenderAction.removeSchedule(id));
            dispatch(rootAction.setReservationPaymentStatus(({ status: true, type: 'deleted' })));
            finishLoading();
        }, 420);
        startLoading();
        // Delete schedule in database
        deleteSchedule(args?.data?.Id, clubId, status)
            .then((res) => {
                debouncedDispatchDelete(args?.data?.Id);
            })
            .catch((error) => {
                finishLoading()
                dialogObj = DialogUtility.alert({
                    title: 'Alert',
                    width: '250px',
                    position: { X: 'center', Y: 'center' },
                    animationSettings: { effect: 'Zoom' },
                    content: "something went wrong",
                    okButton: { click: alertOkAction },
                });
                scheduleRef.current.closeEditor();
            })

    } else {
        console.error('Invalid event ID');
    }
}

//Alert pop up button
const alertOkAction = () => {
    dialogObj.hide();
}


//Hnadle default popup events
export const onPopupOpen = (args, scheduleRef, user, currentGameId, dispatch, clubId, calenderConfig, advanceBookingDay, startLoading, finishLoading, selectedClub, chargesCourtTime = false, navigate) => {


    //Disable Quick Info popup
    if (args.type === "QuickInfo" || args.type === "ViewEventInfo") {
        args.cancel = true;
    }
    if (args.type === 'Editor') {
        setTimeout(() => {
            const saveButton = args.element.querySelector('#reservation_save_button');
            const cancelButton = args.element.querySelector('#Cancel');
            const deleteButton = args.element.querySelector('#Delete');
            if (saveButton) {
                saveButton.onclick = () => {
                    onSaveButtonClick(args, scheduleRef, user, currentGameId, dispatch, clubId, calenderConfig, advanceBookingDay, startLoading, finishLoading, selectedClub, chargesCourtTime, navigate);
                }
            }
            cancelButton.onclick = () => {
                scheduleRef.current.closeEditor();
                scheduleRef.current.refreshTemplates();
            };
            if (deleteButton) {
                let dialogObj;
                deleteButton.onclick = () => {
                    dialogObj = DialogUtility.confirm({
                        title: 'Delete Reservation',
                        content: 'Do you really want to delete the reservation?',
                        width: '300px',
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' },
                        cssClass: 'fixthis',
                        okButton: { click: confirmOkAction },
                        cancelButton: { click: confirmCancelAction }
                    });
                }
                //Execute after user click okay on delete popup
                const confirmOkAction = () => {
                    dialogObj.hide();
                    if (isUser(user) && isReservationInThePast(args?.data?.StartTime)) {
                        dialogObj = DialogUtility.alert({
                            title: 'Alert',
                            width: '250px',
                            position: { X: 'center', Y: 'center' },
                            animationSettings: { effect: 'Zoom' },
                            content: PAST_RESERVATION_COPY,
                            okButton: { click: alertOkAction },
                        });
                        return;
                    }
                    if (args?.data?.Subject === "IN PROGRESS") {
                        onDeleteButtonClick(args, scheduleRef, dispatch, clubId, "DELETED", startLoading, finishLoading);
                    } else if (args?.data?.Subject === "IN PROGRESS" && isClubOwner(user) && args?.data?.Amount === '0') {
                        onDeleteButtonClick(args, scheduleRef, dispatch, clubId, "CANCELED", startLoading, finishLoading);
                    } else if (args?.data?.Subject === "RESERVED" && isClubOwner(user) && args?.data?.Amount === '0') {
                        onDeleteButtonClick(args, scheduleRef, dispatch, clubId, "CANCELED", startLoading, finishLoading);
                    } else if (args?.data?.Subject === "RESERVED" && isClubOwner(user) && args?.data?.Amount === '0') {
                        onDeleteButtonClick(args, scheduleRef, dispatch, clubId, "CANCELED", startLoading, finishLoading);
                    } else if (args?.data?.Subject === "RESERVED" && isClubStaff(user) && args?.data?.Amount === '0') {
                        onDeleteButtonClick(args, scheduleRef, dispatch, clubId, "CANCELED", startLoading, finishLoading);
                    }
                    else if (args?.data?.Subject === "RESERVED") {
                        dispatch(calenderAction.setRefundAmount(Number(args?.data?.Amount).toFixed(2)))
                        dispatch(calenderAction.setOpenRefundPopup(true));
                        dispatch(calenderAction.setReservationId(args?.data?.Id));
                        scheduleRef.current.closeEditor();
                    }
                }
                //Execute after user click cancel on delete popup
                const confirmCancelAction = () => {
                    dialogObj.hide();
                    scheduleRef.current.closeEditor();
                }
            }
        }, 100);

    }
};


//Handle event click methods
export const onEventClick = (args, calenderConfig, user) => {
    let currDate = new Date().toLocaleString("en-US", { timeZone: calenderConfig.calenderTimezone });

    if (isClubOwner(user)) {
        let scheduleObj = document.querySelector('.e-schedule').ej2_instances[0];
        scheduleObj.openEditor(args.event, 'Save');
    } else if (args?.event?.IsReadonly == true) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "You are not authorized to access others' reservations.",
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
    }
    //user can't delete or edit before 1 hour of creation of event
    else if (((args?.event?.StartTime - new Date(currDate)) / (1000 * 60 * 60)) <= 1) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: PAST_RESERVATION_COPY,
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
    }
    else {
        let scheduleObj = document.querySelector('.e-schedule').ej2_instances[0];
        scheduleObj.openEditor(args.event, 'Save');
    }
};

//Handle single click events
export const onSingleClick = (args, scheduleRef, calenderConfig, resourceData, user, advanceBookingDay, privileges, blockedBySubscription = false) => {
    if (!privileges?.RESERVATION?.includes(Privileges.CREATE)) {
        args.cancel = true;
        scheduleRef.current.closeEditor();
        return;
    }
    if (blockedBySubscription) {
        args.cancel = true;
        scheduleRef.current.closeEditor();
        dialogObj = DialogUtility.alert({
            title: 'Subscription required',
            width: '300px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: MEMBER_PLAN_REQUIRED_COPY,
            okButton: { click: alertOkAction },
        });
        return;
    }

    const courtNumber = resourceData?.[args.groupIndex]?.Id ?? resourceData?.[0]?.Id ?? null;
    let currDate = new Date().toLocaleString("en-US", { timeZone: calenderConfig.calenderTimezone });
    let today = new Date(new Date(currDate));
    const tillAdvanceBooking = new Date(today.setDate(today.getDate() + Number(advanceBookingDay)));

    if (!isClubOwner(user) && !isClubStaff(user) && advanceBookingDay != 0 && tillAdvanceBooking < args.startTime) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "You can do advance booking from today up to " + advanceBookingDay + " days",
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
    } else if (checkSlotOpenOrClose(args.startTime, calenderConfig)) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: 'This slot has closed.',
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
        scheduleRef.current.closeEditor()
    } else if (!checkSlot(args.startTime, args.endTime, courtNumber, '', scheduleRef)) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: 'This slot is already booked',
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
    } else if (((args?.endTime - new Date(currDate)) / (1000 * 60)) <= 10) {
        dialogObj = DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: PAST_RESERVATION_COPY,
            okButton: { click: alertOkAction },
        });
        args.cancel = true;
    }
    else {
        scheduleRef.current.openEditor({
            ...args,
            StartTime: args.startTime,
            EndTime: args.endTime,
        }, 'Add');
    }
}

//validation on cells
export const onActionBegin = (args, calenderConfig) => {
    let currDate = new Date().toLocaleString("en-US", { timeZone: calenderConfig.calenderTimezone });
    //user can't edit past data
    if (args.requestType === "eventChange") {
        if (((args?.data?.EndTime - new Date(currDate)) / (1000 * 60)) <= 10) {
            dialogObj = DialogUtility.alert({
                title: 'Alert',
                width: '250px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                content: "You 'can't book in past time'",
                okButton: { click: alertOkAction },
            });

            args.cancel = true;
        }
    }
}


//fetch date accroding to view
export const onActionComplete = (args, scheduleRef, dispatch) => {
    if (args.requestType === "viewNavigate" || args.requestType === "dateNavigate") {
        getCurrentView(scheduleRef, dispatch);
        if (scheduleRef.current?.viewIndex == 0 || scheduleRef.current?.viewIndex == 3) {
            getCurrentDate(scheduleRef, dispatch);
            scheduleRef.current.refreshTemplates();
        }
        if (scheduleRef.current?.viewIndex == 1 || scheduleRef.current?.viewIndex == 2) {
            getCurrentDateByWeek(scheduleRef, dispatch);
            scheduleRef.current.refreshTemplates();
        }
    }
}